// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3HXiS","loaderOuter":"PageOverlayLoader_loaderOuter__2cpY6"};